// ─────────────────────────────────────────────────────────────────────────────
// REQ-124 / REQ-125 — Piezas compartidas de las vistas de métricas (equipo + tablero).
// SIN puntos (regla de oro). Reutiliza las clases rr-* de la reportería (tablas/estados) y añade
// las clases met-* propias (definidas en recognition.css) para las tarjetas KPI.
// ─────────────────────────────────────────────────────────────────────────────
import type { ReactNode } from 'react';
import '../analytics/RecognitionReports.css';
import './metrics.css';

export interface MetricTile {
  label: string;
  value: ReactNode;
  color?: string;
  /** Texto auxiliar bajo el valor (ej: unidad o nota). */
  hint?: string;
}

/** Rejilla de tarjetas KPI (estilo consistente con el resto del módulo). */
export function MetricTiles({ items, className }: Readonly<{ items: MetricTile[]; className?: string }>) {
  return (
    <div className={className ? `met-tiles ${className}` : 'met-tiles'}>
      {items.map((k) => (
        <div key={k.label} className="met-tile">
          <div className="met-tile-value" style={{ color: k.color }}>{k.value}</div>
          <div className="met-tile-label">{k.label}</div>
          {k.hint && <div className="met-tile-hint">{k.hint}</div>}
        </div>
      ))}
    </div>
  );
}
